import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '144ef90f-a4f6-46dd-a541-e65deeacaa26',
	serviceUrl: 'https://api-rel.fundpress.io',
};